var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"width":"100%"}},[_c('v-list-item',{attrs:{"two-line":""}},[_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"subheadline"},[_c('strong',[_vm._v("Total De Incidentes de Desprotección Infantil")])]),_c('v-list-item-subtitle',[_c('strong')])],1)],1),_c('canvas',{attrs:{"id":"planet-chart21"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }